import { SongCard, SidebarStoryFrame } from 'Elements';

export const SidebarStorySong = ({ song, hasMore, onShowMore }) => {
	return (
		<SidebarStoryFrame
			type="sound"
			hasMore={hasMore}
			onShowMore={onShowMore}>
			<SongCard song={song} />
		</SidebarStoryFrame>
	);
};
